import { render, staticRenderFns } from "./PaymentFullCoin.vue?vue&type=template&id=5309a4ed&scoped=true"
import script from "./PaymentFullCoin.vue?vue&type=script&lang=js"
export * from "./PaymentFullCoin.vue?vue&type=script&lang=js"
import style0 from "./PaymentFullCoin.vue?vue&type=style&index=0&id=5309a4ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309a4ed",
  null
  
)

export default component.exports